import { createContext, useContext, useMemo, useRef } from 'react';
import {
  QueryContextData as ContextData,
  QueryContextProps as ContextProps,
  QueryParamsValue,
} from './types';

const QueryContext = createContext<ContextData>({} as ContextData);

const { Provider } = QueryContext;

export const useQueryContext = () => {
  const context = useContext(QueryContext);
  if (!context)
    throw new Error('useQueryContext must be use inside QueryProvider');
  return context;
};

export const QueryProvider = ({ children }: ContextProps) => {
  const previousParamsRef = useRef<Record<string, QueryParamsValue>>();

  const memoizedValue = useMemo<ContextData>(
    () => ({
      get previousParams() {
        return previousParamsRef.current;
      },
      setPreviousParams: (value) => {
        previousParamsRef.current = value;
      },
    }),
    []
  );

  return <Provider value={memoizedValue}>{children}</Provider>;
};
